import React from 'react';
import CategoryList from 'components/Globals/Caroussels/CategoryList';

const ProductsCategoryLayout: React.FC = () => {

    return (
      <div className="container px-0 mt-4 mb-2 relative z-30">
        <CategoryList />
      </div>
    );
};

export default ProductsCategoryLayout;